import * as THREE from "three";
import { BaseModify } from "../base/BaseModify";
import { Context } from "../core/context";
import { DBEntity, DbLine, DbMesh } from "@/CadEngine";
import {
  ModifyOperateState,
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
} from "./IModifyOperation";
import { PipelineModifyState } from "@/core/Parameters";

class PipelineModify implements IModifyOperation {
  private onMouseMoveBind: ((e: PointerEvent) => void) | undefined;
  private onMouseUpBind: ((e: PointerEvent) => void) | undefined;
  private m_context: Context;
  private m_selects: DBEntity[] = [];
  private m_state: PipelineModifyState = PipelineModifyState.UP;
  private callbackData: (DbLine | DbMesh)[] = [];

  constructor(context: Context, type: PipelineModifyState) {
    this.m_context = context;
    this.m_state = type;
    this.m_selects =
      this.m_context.SelectionManager.GetSelected() as DBEntity[];
    if (this.m_selects.length) {
      for (let i = 0; i < this.m_selects.length; i++) {
        let select = this.m_selects[i] as DbLine | DbMesh;
        this.ByDataUpdateModel(select);
      }
      setTimeout(() => {
        this.m_context.ModifyManager.ModifyFinish(ModifyOperateState.complete);
      }, 200);
    }
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {}
  OnDownPoint(point: DrawOperationMovePointParams): void {}
  onKeyDown(e: KeyboardEvent): void {}
  onKeyUp(e: KeyboardEvent): void {}
  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    return this.callbackData;
  }
  OnWheel(e: WheelEvent): void {}

  onMouseMove(e: PointerEvent): void {}
  onMouseDown(e: PointerEvent): void {}
  onMouseUp(e: PointerEvent): void {}

  public ByDataUpdateModel(data: DbLine | DbMesh) {
    let ModelManager = this.m_context.ModelManager;
    let rootId = data.root_reference_id;
    let key = data.layerId + "_" + data.color;
    let lineModel = ModelManager.Lines[key]
      ? ModelManager.Lines[key].model
      : null;
    let meshModel = ModelManager.Meshs[key]
      ? ModelManager.Meshs[key].model
      : null;
    let zData = 0;
    if (this.m_state == PipelineModifyState.UP) {
      zData = this.m_context.ModelManager.MaxZ + 1;
    } else if (this.m_state == PipelineModifyState.DOWN) {
      zData = this.m_context.ModelManager.MinZ - 1;
    }
    let lines = ModelManager.Lines[key] ? ModelManager.Lines[key].lines : null;
    let meshs = ModelManager.Meshs[key] ? ModelManager.Meshs[key].meshs : null;
    if (rootId) {
      let line = ModelManager.Group[rootId].lines[0];
      let mesh = ModelManager.Group[rootId].mesh[0];
      let lineKey = line.layerId + "_" + line.color;
      let meshKey = mesh.layerId + "_" + mesh.color;
      lineModel = ModelManager.Lines[lineKey].model;
      meshModel = ModelManager.Meshs[meshKey].model;
      lines = ModelManager.Lines[lineKey].lines;
      meshs = ModelManager.Meshs[meshKey].meshs;
    }

    if (lineModel && lines) {
      let lineGeoPositions = [];
      for (let i = 0; i < lines.length; i++) {
        if (
          (rootId && rootId == lines[i].root_reference_id) ||
          lines[i].id + lines[i].block_path == data.id + data.block_path
        ) {
          for (let j = 0; j < lines[i].points.length; j++) {
            if ((j + 1) % 3 == 0) {
              lines[i].points[j] = zData;
            }
          }
          if (lines[i].box) {
            lines[i].box!.max.z = zData;
            lines[i].box!.min.z = zData;
          }
          if (lines[i].sphere) lines[i].sphere!.center.z = zData;
          this.callbackData.push(lines[i]);
        }
        lineGeoPositions.push(...lines[i].points);
      }
      lineModel.geometry.setAttribute(
        "position",
        new THREE.Float32BufferAttribute(lineGeoPositions, 3)
      );
    }
    if (meshModel && meshs) {
      let meshGeoPositions = [];
      for (let i = 0; i < meshs.length; i++) {
        if (
          (rootId && rootId == meshs[i].root_reference_id) ||
          meshs[i].id + meshs[i].block_path == data.id + data.block_path
        ) {
          for (let j = 0; j < meshs[i].vertexs.length; j++) {
            if ((j + 1) % 3 == 0) {
              meshs[i].vertexs[j] = zData;
            }
          }
          if (meshs[i].box!.max) {
            meshs[i].box!.max.z = zData;
            meshs[i].box!.min.z = zData;
          }
          if (meshs[i].sphere) meshs[i].sphere!.center.z = zData;
          this.callbackData.push(meshs[i]);
        }
        meshGeoPositions.push(...meshs[i].vertexs);
      }
      meshModel.geometry.setAttribute(
        "position",
        new THREE.Float32BufferAttribute(meshGeoPositions, 3)
      );
    }
    if (this.m_state == PipelineModifyState.UP) {
      this.m_context.ModelManager.MaxZ = zData;
    } else if (this.m_state == PipelineModifyState.DOWN) {
      this.m_context.ModelManager.MinZ = zData;
    }
  }
}

export { PipelineModify, PipelineModifyState };
